/* eslint-disable no-mixed-spaces-and-tabs */
import { TSizes } from '@customTypes/variants'
import { Backdrop, CircularProgress, Typography } from '@mui/material'

import * as S from './styles'

//TODO change size api to accommodate for a smaller progress sizing
interface ILoadingProps {
	size?: TSizes
	text?: string
	color?: string
	backdrop?: boolean
	isModal?: boolean
	noWrapper?: boolean
	progressSize?: string
	containerHeight?: string
}

const Loading = ({
	containerHeight,
	size,
	color,
	text,
	noWrapper = false,
	backdrop = false,
	isModal = false,
	progressSize = size === 'small' ? '20px' : '40px',
}: ILoadingProps) => {
	const isLarge = size === 'medium'
	const style = isLarge
		? ({
				position: isModal ? 'fixed' : 'absolute',
				top: 0,
				bottom: 0,
				left: 0,
				right: 0,
				height: '100vh',
				width: '100vw',
				backgroundColor: 'rgba(0, 0, 0, 0.8)',
				color,
			} as const)
		: ({
				height: containerHeight,
				color,
			} as const)
	return (
		<Backdrop
			sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
			open={backdrop}
		>
			{noWrapper ? (
				<CircularProgress size={progressSize} />
			) : (
				<S.Wrapper style={style} id="loader">
					<CircularProgress size={progressSize} />
					{text && <Typography>{text}</Typography>}
				</S.Wrapper>
			)}
		</Backdrop>
	)
}

export { Loading }
